import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import PhotoUploader from './components/PhotoUploader';
import AuthHandler from './components/AuthHandler';
import { BrowserRouter as Router } from 'react-router-dom';
import { FaUser, FaShieldAlt } from 'react-icons/fa';

function App() {
  const [userName, setUserName] = useState('');
  const [userNameMobile, setUserNameMobile] = useState('');
  const photoUploaderRef = useRef(null);

  const handleLogoClick = () => {
    if (photoUploaderRef.current) {
      photoUploaderRef.current.resetToStart();
    }
  };

  useEffect(() => {
    const givenName = sessionStorage.getItem('userGivenName');
    const surname = sessionStorage.getItem('userSurname');
    if (givenName && surname) {
      // Full name for desktop
      setUserName(`${givenName} ${surname}`);
      // Mobile format: FirstName S.
      setUserNameMobile(`${givenName.charAt(0)}${surname.charAt(0)}`);
    }
  }, []);

  return (
    <Router>
      <AuthHandler>
        <div className="App bg-gray-50 font-sans">
          <header className="bg-eab-blue shadow-sm">
            <div className="container mx-auto px-4 py-3 flex items-center justify-between max-w-6xl">
              <div className="flex items-center flex-shrink-0">
                <img 
                  src="/logo.svg" 
                  alt="EAB Logo" 
                  className="h-6 md:h-8 w-auto cursor-pointer"
                  onClick={handleLogoClick}
                  title="Go to Upload Photo"
                />
              </div>
              <div className="flex-1 flex justify-center px-2">
                <h1 className="text-white text-center font-medium text-base md:whitespace-nowrap font-heading" style={{ fontSize: 'clamp(14px, 4vw, 26px)' }}>My EAB Photo Uploader</h1>
              </div>
              <div className="flex items-center flex-shrink-0">
                {userName && (
                  <>
                    {/* Mobile name display - FirstName S. */}
                    <span className="md:hidden text-xs text-white mr-2">{userNameMobile}</span>
                    {/* Desktop name display - Full Name */}
                    <span className="hidden md:inline text-white mr-2" style={{ fontSize: '16px' }}>{userName}</span>
                    <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-white flex items-center justify-center text-eab-blue flex-shrink-0">
                      <FaUser className="text-xs md:text-sm" />
                    </div>
                  </>
                )}
              </div>
            </div>
          </header>

          <main className="app-content">
            <div className="w-full max-w-7xl mx-auto px-4">
              <PhotoUploader ref={photoUploaderRef} />
            </div>
          </main>

          <footer className="bg-white border-t border-gray-200">
            <div className="container mx-auto px-4 md:px-4 px-3 py-4 md:py-4 py-2 max-w-6xl">
              <div className="flex md:flex-row flex-col md:justify-between md:items-center items-center text-center">
                <div className="text-sm md:text-sm text-xs text-gray-500 md:mb-0 mb-0.5">
                © {new Date().getFullYear()} EAB. All rights reserved.
                </div>
                <div className="flex items-center text-sm md:text-sm text-xs text-gray-500">
                  <FaShieldAlt className="mr-2 md:mr-2 mr-1 text-eab-blue text-sm md:text-sm text-xs" />
                  Your data is secure and encrypted
                </div>
              </div>
            </div>
          </footer>
        </div>
      </AuthHandler>
    </Router>
  );
}

export default App;
